import { render, staticRenderFns } from "./ChangeInstructions.vue?vue&type=template&id=3b1f5e86&"
import script from "./ChangeInstructions.vue?vue&type=script&lang=js&"
export * from "./ChangeInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b1f5e86')) {
      api.createRecord('3b1f5e86', component.options)
    } else {
      api.reload('3b1f5e86', component.options)
    }
    module.hot.accept("./ChangeInstructions.vue?vue&type=template&id=3b1f5e86&", function () {
      api.rerender('3b1f5e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ChangePrimary/ChangeInstructions.vue"
export default component.exports